<template>
  <container>
    <h1 style="font-size:25px;text-align:center">Settings</h1>

    <div class="bannersList">
      <div class="add-banner-header">
        <h2>Banners</h2><img style="cursor:pointer;" @click="showBannerModal('Add')" src="../../../assets/add-banner.png"/>
      </div>

      <div>
        <div v-for="Banner in bannerList" :key="Banner.id" class="banners">
            <div id="previewBanners" class="bannerLandscape" >
              <h1>{{Banner.Type}}</h1>
              <div style="display:flex">
                <img  :src="Banner.ImageUrl">
                <div class="operation">
                  <img style="cursor:pointer;" @click="showBannerModal('Edit',Banner)" src="../../../assets/edit2.png"/>                
                  <v-popover offset="16" placement = 'right' >
                    <a class="tooltip-target b3"  style="cursor: pointer;"><img src="../../../assets/delete2.png"/></a>

                    <template slot="popover">
                      <p>
                        {{ msg }}
                      </p>
                      <br/>
                      <div style="display:flex; padding-left: 5rem;">
                        <button class="btn btn--danger" @click="deleteBanner(Banner)" >Yes</button>
                          &nbsp;&nbsp;&nbsp;
                        <button class="btn btn--gray" v-close-popover>No</button>
                      </div>
                    </template>
                </v-popover>
                
                </div>
              </div>              
            </div>
        </div>

         <add-edit-banner :show="showAddEditBannerModal" :type="bannerOpr" :bannerData="bannerData" @saved="onSaved" @closed="onClosed"></add-edit-banner> 
      </div>



    </div>

    

    <div style="margin-top: 30px;">
      <p>
        File Updated:
        <a
          href="https://s3-ap-northeast-1.amazonaws.com/static.liverunapp.com/app/v1.json"
          target="blank"
        >https://s3-ap-northeast-1.amazonaws.com/static.liverunapp.com/app/v1.json</a>
      </p>
    </div>

<br/><br/>
   <!-- Audio Channel A -->
  <div class="form__group" style="display:flex;">
      <h1 style="font-size:15px;display:flex; width: 10%; align-items: center;">Audio Channel A: </h1>
      <text-field   name="channelLinkA"  data-vv-value-path="input" data-vv-name="channelLinkA"  v-model="channelLinkA"  style="width: 35%;"></text-field>
      
      <div class="form__group" style="display:flex;">
        <button
          class="btn btn--primary"
          id="submit-form"
          @click="onAddChannelA()"
        >Add</button>
      </div> 
      <div class="form__group" style="display:flex;margin: 1rem 0rem 0rem 5rem;" v-if="linkAError">
            <p style="color:red">{{linkAError}}</p>
      </div>
      <div class="form__group" style="display:flex;margin: 1rem 0rem 0rem 5rem;" v-if="audioChannelA">
        saved URL &nbsp;&nbsp;<a :href="audioChannelA" target="blank"> {{audioChannelA}}</a>
      </div>
  </div>
 <!-- Audio Channel B -->   
<div class="form__group" style="display:flex;">
      <h1 style="font-size:15px;display:flex; width: 10%; align-items: center;">Audio Channel B: </h1>
      <text-field   name="channelLinkB"  data-vv-value-path="input" data-vv-name="channelLinkB"  v-model="channelLinkB"  style="width: 35%;"></text-field>
      <div class="form__group" style="display:flex;">
        <button
          class="btn btn--primary"
          id="submit-form"
          @click="onAddChannelB()"
        >Add</button>
      </div> 
      <div class="form__group" style="display:flex;margin: 1rem 0rem 0rem 5rem;" v-if="linkBError">
            <p style="color:red">{{linkBError}}</p>
      </div>
      <div class="form__group" style="display:flex;margin: 1rem 0rem 0rem 5rem;" v-if="audioChannelB">
       saved URL &nbsp;&nbsp; <a :href="audioChannelB" target="blank"> {{audioChannelB}}</a>
      </div>
  </div>
<!-- Audio Channel C -->
  <div class="form__group" style="display:flex;">
      <h1 style="font-size:15px;display:flex; width: 10%; align-items: center;">Audio Channel C: </h1>
      <text-field   name="channelLinkC"  data-vv-value-path="input" data-vv-name="channelLinkC"  v-model="channelLinkC"  style="width: 35%;"></text-field>
      <div class="form__group" style="display:flex;">
        <button
          class="btn btn--primary"
          id="submit-form"
          @click="onAddChannelC()"
        >Add</button>
      </div> 
      <div class="form__group" style="display:flex;margin: 1rem 0rem 0rem 5rem;" v-if="linkCError">
            <p style="color:red">{{linkCError}}</p>
      </div>
      <div class="form__group" style="display:flex;margin: 1rem 0rem 0rem 5rem;" v-if="audioChannelC">
        saved URL &nbsp;&nbsp; <a :href="audioChannelC" target="blank"> {{audioChannelC}}</a>
      </div>
  </div>

  <!-- Audio Channel D -->
  <div class="form__group" style="display:flex;">
      <h1 style="font-size:15px;display:flex; width: 10%; align-items: center;">Audio Channel D: </h1>
      <text-field   name="channelLinkD"  data-vv-value-path="input" data-vv-name="channelLinkD"  v-model="channelLinkD"  style="width: 35%;"></text-field>
      <div class="form__group" style="display:flex;">
        <button
          class="btn btn--primary"
          id="submit-form"
          @click="onAddChannelD()"
        >Add</button>
      </div> 
      <div class="form__group" style="display:flex;margin: 1rem 0rem 0rem 5rem;" v-if="linkDError">
            <p style="color:red">{{linkDError}}</p>
      </div>
      <div class="form__group" style="display:flex;margin: 1rem 0rem 0rem 5rem;" v-if="audioChannelD">
        saved URL &nbsp;&nbsp; <a :href="audioChannelD" target="blank"> {{audioChannelD}}</a>
      </div>
  </div>

    <!-- Switch between Live & Staging API's Section -->
    <div style="border: 1px solid #ccc;
    padding: 1rem;
    border-radius: 10px;
    margin-top: 2rem;
    width: 50%;
    background: #f9f9f9;">
      <h1 style="font-size:20px;">Mode  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 

        <toggle-button
          id="changed-font"
          @change="onToggle()"
          v-model="alert"
          :width="85"
          :height="30"
          :speed="480"
          :color="{checked: '#ff5627', unchecked: '#413b94'}"
          :labels="{checked: 'STAGING', unchecked: 'LIVE'}"
          style="float:right"/>
        </h1>
        <p style="    font-size: 11px;
    color: #4a4747;">&#9432; Do not switch between API environment while live run is happening!</p>
    
    </div>
  </container>
</template>
<script>
import Container from "@/components/Container"
import { mapActions, mapGetters } from "vuex"
import S3UploadService from "@/services/s3Upload"
import SettingsService from "@/services/settings"
import TextField from '@/components/Forms/TextField'
import AddEditBanner from './BannerManger/AddEditBanner'
import Vue from 'vue'
import axios from 'axios'
export default {
  name: "settings",
  data() {
    return {
      hasError: false,
      errorMessage: "Fill in the photo with size below 1 mb",
      choosed: true,
      file: {},
      url: null,
      aspectRatioError: null,
      uploadingBar: false,
      uploadPercentage: 0,
      interval: null,
      suceessmessage: null,
      banner:null,
      bannerlink:null,
      msg:'Are you sure want to remove banner?',
      link:null,
      suceessLinkMessage:false,
      linkError:null,


      hasUsError: false,
      usErrorMessage: "Fill in the photo with size below 1 mb",
      usChoosed: true,          
      usFile: {},
      usUrl:null,
      usAspectRatioError: null,
      usSuceessMsg: null,  
      USbanner:null,
      USbannerlink:null,
      usLink:null,
      usSuceessLinkMessage:false,
      usLinkError:null,    
     
      channelLinkA:null,
      channelLinkB:null,
      channelLinkC:null,      
      channelLinkD:null,
      linkAError:null,
      linkBError:null,
      linkCError:null,
      linkDError:null,
      
      // status:'Staging'
      alert: false,
      audioChannelA:null,
      audioChannelB:null,
      audioChannelC:null,
      audioChannelD:null,

      bannerList:[],
      showAddEditBannerModal:false,
      bannerData:{},
      bannerOpr:''

    }
  },
  computed: {
    // alert () {
    //   return this.$store.getters['Alert/alert']
    // }
  },
  methods: {
     ...mapActions({
      setAlert: 'Alert/setAlert',
    }),

    async onToggle(){
      if(this.$envStatus ==='Live'){
          this.alert = false
          Vue.prototype.$envStatus = 'Staging'
          Vue.prototype.$isStage = 0
          Vue.prototype.$fbDbEntry = 'racers'
           Vue.http.options.root = 'https://app.liverunapp.com/api'
          window.localStorage.setItem('envStatus','Staging')
          this.setAlert(false)
          this.$router.go()
      }else if(this.$envStatus ==='Staging'){
          this.alert = true
          Vue.prototype.$envStatus = 'Live' 
          Vue.prototype.$isStage = 1
          Vue.prototype.$fbDbEntry = 'racers-test'
           if (await this.checkDevServer()) {
            Vue.http.options.root = 'https://devapp.liverunapp.com/api'
          } else {
            Vue.http.options.root = 'https://liverunapi.npit.xyz/api'
          }

          //Vue.http.options.root = 'https://devapp.liverunapp.com/api'
          window.localStorage.setItem('envStatus','Live')
          this.setAlert(true)
          this.$router.go()
      }
    },
    async checkDevServer() {
        try {
          let data = await axios.get('https://devapp.liverunapp.com/')
          return true
        } catch (err) {
          return false
        }
      },
  
    changeFileHandle(e) {
    
      this.suceessmessage = null
      
      const originalFile = e.target.files[0]
      this.url = URL.createObjectURL(originalFile)
      const file = new FormData()
      file.append("file", originalFile)
      const size = originalFile.size / 1024
      if (size > 1024) {
        this.hasError = true
        this.aspectRatioError = null
        this.choosed = true
      } else {
        this.choosed = false

        this.file.name = originalFile.name
        this.file.data = originalFile
      }
    },
    onupload() {
      let aspectRatio =
        document.getElementById("image").clientWidth /
        document.getElementById("image").clientHeight
        aspectRatio = Math.round(aspectRatio)
      if (aspectRatio == 3) {
        this.aspectRatioError = null
         this.hasError = false
        this.uploadingBar = true
        this.startBar()
        S3UploadService.uploadToS3(this.file,"NORMAL", (data, err) => {
          this.stopBar()
          this.uploadingBar = false
          this.uploadPercentage = 0
          this.suceessmessage = true
          this.url = null
          this.choosed = true
          setTimeout(()=>{
            this.suceessmessage = false            
          },2000)

          this.getExistingBanner()
        })
      } else {
        this.aspectRatioError = "Please upload 3:1 aspect ratio Image"
        this.choosed = true
          this.errorMessage = null
        
      }
    },
    async onAddBannerLink(){              
         const valid =  await this.isUrlValid(this.link)     
              if(valid){
                this.linkError = null
                S3UploadService.updateBannerLink(this.link,'NORMAL',(data,err)=>{
                  this.suceessLinkMessage = true
                    setTimeout(()=>{
                    this.suceessLinkMessage = false            
                  },2000)
                   this.getExistingBanner()
                })
              }else{
                this.linkError = 'Banner link is not valid or empty!'
              }
    },    
    async onAddUSBannerLink(){              
         const valid =  await this.isUrlValid(this.usLink)     
              if(valid){
                this.usLinkError = null
                S3UploadService.updateBannerLink(this.usLink,'US',(data,err)=>{
                  this.usSuceessLinkMessage = true
                    setTimeout(()=>{
                    this.usSuceessLinkMessage = false            
                  },2000)
                   this.getExistingBanner()
                })
              }else{
                this.usLinkError = 'Banner link is not valid or empty!'
              }
    },
    selectNoBanner(banner) {
      S3UploadService.selectNoImage(banner, (data, err) => {
        this.getExistingBanner()
      })
    },
    startBar() {
      this.interval = setInterval(() => {
        this.uploadPercentage += 10
      }, 200)
    },
    stopBar() {
      clearInterval(this.interval)
    },
    isUrlValid(userInput) {
       if(userInput == null)
            return false
        var res = userInput.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g)
        if(res == null)
            return false
        else
            return true
    },
  changeUSFileHandle(e) {
    
      this.usSuceessMsg = null
      
      const originalFile = e.target.files[0]
      this.usUrl = URL.createObjectURL(originalFile)
      const file = new FormData()
      file.append("file", originalFile)
      const size = originalFile.size / 1024
      if (size > 1024) {
        this.hasUsError = true
        this.usAspectRatioError = null
        this.usChoosed = true
      } else {
        this.usChoosed = false

        this.usFile.name = originalFile.name
        this.usFile.data = originalFile
      }
    },
    onuploadUsBanner() {
      let aspectRatio =
        document.getElementById("us-image").clientWidth /
        document.getElementById("us-image").clientHeight
        aspectRatio = Math.round(aspectRatio)
      if (aspectRatio == 3) {
        this.usAspectRatioError = null
         this.hasUsError = false
        this.uploadingBar = true
        this.startBar()
        S3UploadService.uploadToS3(this.usFile,'US', (data, err) => {
          this.stopBar()
          this.uploadingBar = false
          this.uploadPercentage = 0
          this.usSuceessMsg = true
          this.usUrl = null
          this.usChoosed = true
          setTimeout(()=>{
            this.usSuceessMsg = false            
          },2000)

          this.getExistingBanner()
        })
      } else {
        this.usAspectRatioError = "Please upload 3:1 aspect ratio Image"
        this.usChoosed = true
        this.usErrorMessage = null
        
      }
    },

    
    getExistingBanner(){
       S3UploadService.getUploadedBanner((data, err) => {
        this.banner = data.view.top_banner_image_url
        this.bannerlink = data.view.top_banner_link_url
        this.USbanner = data.view_us.top_banner_image_url
        this.USbannerlink = data.view_us.top_banner_link_url
          // var img = new Image()
          // img.onload = function(){
          //     alert( this.width+' '+ this.height )
          // }
          // img.src = this.banner
    })
    },
    async onAddChannelA(){
      const valid =  await this.isUrlValid(this.channelLinkA)     
      if(valid){
        this.linkAError = null
        await SettingsService.update({audioChannelA:this.channelLinkA})
        this.audioChannelA = this.channelLinkA
      }else{
        this.linkAError = 'Channel A link is not valid or empty!'
      }
    },
    async onAddChannelB(){
     const valid =  await this.isUrlValid(this.channelLinkB)     
      if(valid){
        this.linkBError = null
        await SettingsService.update({audioChannelB:this.channelLinkB})
        this.audioChannelB = this.channelLinkB
      }else{
        this.linkBError = 'Channel B link is not valid or empty!'
      }
    },
    async onAddChannelC(){
     const valid =  await this.isUrlValid(this.channelLinkC)     
      if(valid){
        this.linkCError = null
        await SettingsService.update({audioChannelC:this.channelLinkC})
        this.audioChannelC = this.channelLinkC
      }else{
        this.linkCError = 'Channel C link is not valid or empty!'
      }
    },
     async onAddChannelD(){
     const valid =  await this.isUrlValid(this.channelLinkD)     
      if(valid){
        this.linkDError = null
        await SettingsService.update({audioChannelD:this.channelLinkD})
        this.audioChannelD = this.channelLinkD
      }else{
        this.linkDError = 'Channel D link is not valid or empty!'
      }
    },
    async getExistingChannels(){
       const channels = await SettingsService.get()
       if(channels){
        this.audioChannelA  = channels.data.audioChannelA
        this.audioChannelB  = channels.data.audioChannelB
        this.audioChannelC  = channels.data.audioChannelC
        this.audioChannelD  = channels.data.audioChannelD
       }      
    },
    getBannerList(){
        const AuthStr = 'Bearer '.concat(window.localStorage.getItem('default-auth-token'))
        axios.get(this.$expressApi+`banners?staging=`+this.$isStage, { headers: { Authorization: AuthStr } })
          .then(response =>{ 
            console.log("response---->>",response.data)
            if(response.data!=undefined && response.data!=null){
            this.bannerList = response.data
            }
          }).catch(e => {
            console.log("Error from Api -->",e)
        })
      
    },
    deleteBanner(banner){
      axios.post(this.$expressApi+`deleteBanner?staging=`+this.$isStage,banner)
        .then(response =>{ 
          console.log("delete response---->>",response.data)
          this.getBannerList()
        }).catch(e => {
          console.log("Error from Api -->",e)
      })
      
    },
    showBannerModal(type,data){
      this.bannerData = {}
      if(type == 'Edit'){
         this.bannerData = data
      }     
      this.bannerOpr = type
      this.showAddEditBannerModal = true
    },
    onClosed(){
      this.showAddEditBannerModal=false 
    },
    onSaved(){
      this.getBannerList()
    }

  },
  created() {
    if(this.$envStatus == 'Staging'){
      this.alert = false
    }else{
      this.alert = true
    }
  this.getBannerList()
   this.getExistingBanner()
   this.getExistingChannels()
  },
  watch: {},
  components: {
    Container,
    TextField,
    AddEditBanner
  }
}
</script>

<style>
#preview {
  width: 50%;
}
.landscape {
    height: 300px;
    width: 100px;
    padding: 1rem;
}
img {
    max-width: 100%;
    max-height: 100%;
}
.tooltip {
  display: block !important;
  z-index: 10000;
}
.tooltip .tooltip-inner {
  background: #3a1f8a;
  color: white;
  border-radius: 5px;
  padding: 10px 15px 10px;
}
.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: #3a1f8a;
}
.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}
.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  content: " ";
  position: absolute;
  top: 50%;
  right: 98%; 
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent #3a1f8a transparent transparent;
}

.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}
.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}

.apiStatusStaging{
  background-color: #ff5e00;
  border: 2px solid #ff5e00;
  color: white;
  border-radius: 2rem;
  padding: 5px 15px;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  outline:0;
  float: right;
}
.apiStatusLive{
  background-color: #3b3586;
  border: 2px solid #3b3586;
  color: white;
  border-radius: 2rem;
  padding: 5px 15px;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  outline:0;
  float: right;
}
p.us-banner {
    font-size: 20px;
    font-weight: bold;
    color: #423799;
    margin-bottom: 10px;
    margin-top: 50px;
}

.tabs-component {
  margin: 1em 0;
}

.tabs-component-tabs {
  border: solid 1px #ddd;
  border-radius: 6px;
  margin-bottom: 5px;
}

/****** Add banner design***** */
.add-banner-header {
    padding: 15px 1rem;
}

.add-banner-header h2{
  font-size: 20px;
  float:left;
  margin-right: 20px;
}

#previewBanners {
  width: 50%;
}
.bannerLandscape {
  height: 230px;
  width: 100px;
  padding: 1rem;
}
.banners .operation{
  margin-left: 10px;  
  min-width: 20px;
}
.bannersList{
  padding: 20px 0;
  /* border: 1px solid #efefef; */
  border: solid 1px #ddd;
  border-radius: 6px;
  box-shadow: 0 0 10px rgba(0, 0, 0, .05);
  margin: 20px 0px;
}

@media (min-width: 700px) {
  .tabs-component-tabs {
    border: 0;
    align-items: stretch;
    display: flex;
    justify-content: flex-start;
    margin-bottom: -1px;
  }
}

.tabs-component-tab {
  color: #999;
  font-size: 14px;
  font-weight: 600;
  margin-right: 0;
  list-style: none;
}

.tabs-component-tab:not(:last-child) {
  border-bottom: dotted 1px #ddd;
}

.tabs-component-tab:hover {
  color: #666;
}

.tabs-component-tab.is-active {
  color: #ffffff;
  background: #423799;
}

.tabs-component-tab.is-disabled * {
  color: #cdcdcd;
  cursor: not-allowed !important;
}

@media (min-width: 700px) {
  .tabs-component-tab {
    background-color: #fff;
    border: solid 1px #ddd;
    border-radius: 3px 3px 0 0;
    margin-right: .5em;
    /* transform: translateY(2px); */
    transition: transform .3s ease;
  }

  .tabs-component-tab.is-active {
    border-bottom: solid 1px #fff;
    z-index: 2;
    /* transform: translateY(0); */
  }
}

.tabs-component-tab-a {
  align-items: center;
  color: inherit;
  display: flex;
  padding: .75em 1em;
  text-decoration: none;
}

.tabs-component-panels {
  padding: 2em 0;
}

@media (min-width: 700px) {
  .tabs-component-panels {
    border-top-left-radius: 0;
    background-color: #fff;
    border: solid 1px #ddd;
    border-radius: 0 6px 6px 6px;
    box-shadow: 0 0 10px rgba(0, 0, 0, .05);
    padding: 2em 2em;
  }
}
</style>



// WEBPACK FOOTER //
// Settings.vue?2470e470